import { makeStyles, css } from '@conexasaude/conexa-hero'

import type { ConsultationCardProps } from './index'

const useStyles = makeStyles<Pick<ConsultationCardProps, 'isCancelled'>>({
  cardProfessionalInfo: theme => css`
    padding: ${theme.spacing.xs};
  `,

  cardFooter: theme => css`
    display: flex;
    justify-content: flex-end;
    gap: ${theme.spacing.xxs};
    margin-top: ${theme.spacing.md};
  `,

  base: theme => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing.xxs};
  `,

  cardConsultationInfo: (theme, props) => css`
    margin-top: ${theme.spacing.xs};
    padding-top: ${theme.spacing.xs};
    border-top: 1px solid ${theme.colors.neutral[100]};

    > div {
      + div {
        margin-top: ${theme.spacing.xs};
      }

      span:not(.mantine-Badge-inner) {
        margin-left: ${theme.spacing.xxs};
        color: ${props?.isCancelled
          ? theme.colors.neutral[300]
          : theme.colors.neutral[500]};
      }
    }
  `,
})

export { useStyles }
